module.exports = __webpack_public_path__ + "img/portfolio-09-480x343.9f91a642.jpg";